import { z } from "zod";
/**
 * BEDES request schemas — shared by the Hono api routes and the web UI
 * (import dialog / transform tester). See docs/BEDES.md.
 */
/** One source mapping-list row: 7 or 9 loosely-typed columns. */
export const bedesMappingRowSchema = z
    .array(z.union([z.string(), z.number(), z.null()]))
    .refine((row) => row.length === 7 || row.length === 9, {
    message: "mapping rows have exactly 7 or 9 columns",
});
/** Source mapping-list JSON: an array of rows (a leading header row is allowed). */
export const bedesMappingRowsSchema = z.array(bedesMappingRowSchema).min(1);
export const bedesImportMappingListSchema = z.object({
    mappingList: z.string().trim().min(1).max(200),
    rows: bedesMappingRowsSchema,
});
export const bedesTransformDirectionSchema = z.enum(["to_bedes", "to_source"]);
export const bedesTransformRequestSchema = z.object({
    mappingListId: z.string().trim().min(1).max(512),
    fieldName: z.string().min(1).max(300),
    direction: bedesTransformDirectionSchema,
    value: z.union([z.string(), z.number(), z.null()]),
    unit: z.string().max(100).nullish(),
});
//# sourceMappingURL=bedes.js.map